var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('md-toolbar',{staticClass:"md-dense"},[_c('md-layout',{attrs:{"md-align":"start"}},[_c('md-icon',{staticClass:"displayIcon md-size-2x"},[_vm._v(_vm._s(_vm.displayIcon))]),_vm._v(" "),_c('h2',{staticStyle:{"flex":"1, float: left"}},[_vm._v(_vm._s(_vm.getSingleImage._source.places[0] || 'Location'))])],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"image-map"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f6506f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/singleItemMap.vue
// module id = fJkV
// module chunks = 1